import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import NavBar from "Root/profile/components/Navigation/NavBar";
import { apiGetUpsellRecommendations, apiGetBaseProfile } from "Root/api/apiQuiz";
// import { apiGetAnswers } from "Root/api/apiProfile";
import { useDispatch, useSelector } from "react-redux";
import GainfulLoading from "Components/GainfulLoading";
import CartContainer from "../cartContainer/index";
import TopBanner from "../topBanner/index";
import PersonalizedBoost from "../personalizedBoost/index";
import Happiness from "../happiness/index";
import Reviews from "../reviews/index";
import { Footer } from "Root/checkout/components/Footer";
import styles from "./style.module.css";
import SubscriptionContainer from "../subscriptionContainer";
import Loading from "Components/Loading";
import LoadProfileInfoThunk from "Root/profile/redux/thunkCreators/user/user";
import { fetchSeasonalPromotion } from "Root/profile/redux/slices/profileSeasonalPromotionSlice";
import httpService from "Root/api/httpService";
const UpsellPageContent = () => {
    const personalizedBoostRef = useRef(null);
    const [personalizedItems, setPersonalizedItems] = useState([]);
    const [boostsItems, setBoostsItems] = useState([]);
    const { loading } = useSelector((state) => state.components);
    const isProfile = window.location.pathname.includes("app");
    const [userLoggedIn, setUserLoggedIn] = useState(false || isProfile);
    const [bannerText, setBannerText] = useState("");
    const [userHasOrdered, setUserHasOrdered] = useState(isProfile);
    const user = useSelector((state) => state.user);
    const [localLoading, setLocalLoading] = useState(false);
    const dispatch = useDispatch();
    const showPersonalizedFirst = personalizedItems && personalizedItems.length > 0 && personalizedItems.filter((item) => item.is_in_cart).length < 3;
    const scrollToNextSection = () => personalizedBoostRef.current.scrollIntoView({
        block: "start",
        behavior: "smooth",
    });
    const fetchUpsellRecommendations = async () => {
        const { personalized, boosts } = await apiGetUpsellRecommendations();
        setPersonalizedItems(personalized);
        setBoostsItems(boosts);
    };
    const fetchPromoBanner = async () => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const endpoint = params.has("code") ? `/api/get-promo-banner/?code=${code}` : "/api/get-promo-banner/";
        const data = await httpService.get(endpoint);
        setBannerText(data.bannerText);
    };
    useEffect(() => {
        fetchPromoBanner();
    }, []);
    const fetchBaseProfile = async () => {
        try {
            const { hasOrdered } = await apiGetBaseProfile(true);
            setUserLoggedIn(true);
            setUserHasOrdered(hasOrdered);
        }
        catch (e) {
            setUserLoggedIn(false);
            setUserHasOrdered(false);
        }
    };
    const fetchAllData = async () => {
        setLocalLoading(true);
        await fetchBaseProfile();
        await fetchUpsellRecommendations();
        await dispatch(fetchSeasonalPromotion());
        if (!user.email) {
            try {
                await dispatch(LoadProfileInfoThunk());
            }
            catch (e) {
                // this will fail whenever the user isn't logged in
                // so it makes sense to simply catch it and display the page
                // TODO: find a better, long term fix for this
                setLocalLoading(false);
            }
        }
        setLocalLoading(false);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchAllData();
    }, []);
    return (_jsxs(_Fragment, { children: [bannerText !== "" && (_jsx("div", { id: "bannerText", className: styles.bannerText, style: { background: "#ecff7a", textAlign: "center", padding: "5px" }, children: _jsx("div", { style: { maxWidth: "80%", margin: "auto" }, children: _jsx("span", { children: bannerText.toUpperCase() }) }) })), _jsx(NavBar, { userName: user.full_name, showTop: false, userLoggedIn: userLoggedIn, bannerText: bannerText }), _jsxs("div", { className: styles.back, children: [!localLoading && userHasOrdered ? (_jsx("div", { className: styles.container, children: _jsx("h1", { className: styles.title, children: "Products" }) })) : (!localLoading && _jsx(TopBanner, { scroll: scrollToNextSection, logined: userLoggedIn })), localLoading && (_jsxs(_Fragment, { children: [_jsx(Loading, {}), _jsx(Loading, {}), _jsx(Loading, {})] })), !localLoading && showPersonalizedFirst && showPersonalizedFirst ? (_jsx("div", { ref: personalizedBoostRef, children: userHasOrdered ? (_jsxs(SubscriptionContainer, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, children: [_jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, personalized: true, products: personalizedItems }), _jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, products: boostsItems })] })) : (_jsxs(CartContainer, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, children: [_jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, personalized: true, products: personalizedItems }), _jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, products: boostsItems })] })) })) : (!localLoading && (_jsx("div", { ref: personalizedBoostRef, children: userHasOrdered ? (_jsxs(SubscriptionContainer, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, children: [_jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, products: boostsItems }), _jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, personalized: true, products: personalizedItems })] })) : (_jsxs(CartContainer, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, children: [_jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, products: boostsItems }), _jsx(PersonalizedBoost, { loggedIn: userLoggedIn, hasOrdered: userHasOrdered, personalized: true, products: personalizedItems })] })) }))), _jsx(Happiness, {}), _jsx(Reviews, {})] }), !isProfile && _jsx(Footer, { profileFooter: true, userLoggedIn: true }), loading && _jsx(GainfulLoading, {})] }));
};
export default UpsellPageContent;
